// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyBxsiudzcOiBJ1G_uHMeXhpH_Jss-9SEP0",
  authDomain: "meetsync-44de9.firebaseapp.com",
  projectId: "meetsync-44de9",
  storageBucket: "meetsync-44de9.firebasestorage.app",
  messagingSenderId: "832212025596",
  appId: "1:832212025596:web:16c8894b57323b6c8d1779"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Cloud Function callables
export const createAtomicBooking = httpsCallable(functions, 'createAtomicBooking');
export const cancelBookingFn = httpsCallable(functions, 'cancelBooking');

export default app;
